import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../../SimpleBlockContent'
import { $neutralGray50 } from '../../../../../styles/colors/primitives'
import Img from '../../../../Img'
import Spacer from '../../../../Spacer'
import Specs from '../../Specs'

const cx = (...c) => c.filter(Boolean).join(' ')

function LiteWheelSpecs({ title1, text1, title2, text2, text3, image1, image2, specs }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.row}>
          <div className={styles.title}>
            <SimpleBlockContent
              blocks={title1.text}
              highlight={title1.highlight}
              highlightSx={`color: ${$neutralGray50};`}
              highlightExactMatch={true}
              noSpace
            />
          </div>
          <div className={styles.textBody}>
            <SimpleBlockContent blocks={text1} noSpace/>
            <Specs specs={specs}/>
          </div>
        </div>
        <div className={styles.imagesRow}>
          { image1 && (
            <div className={styles.image1}>
              {/* task #67: image1 is now a ResolvedImage descriptor */}
              <Img
                image={image1}
                alt={title1.text}
                layout="fill"
                objectFit="contain"
              />
            </div>
          )}
          {
            image2 && (
              <div className={styles.image2}>
                {/* task #67: image2 is now a ResolvedImage descriptor */}
                <Img
                  image={image2}
                  alt={title1.text}
                  layout="fill"
                  objectFit="contain"
                />
              </div>
            )
          }
        </div>
        <div className={cx(styles.row, styles.rowAlignItemsEnd)}>
          <div className={styles.title}>
            <SimpleBlockContent
              blocks={title2.text}
              highlight={title2.highlight}
              highlightSx={`color: ${$neutralGray50};`}
              highlightExactMatch={true}
              noSpace
            />
            <Spacer size={32}/>
            <div className={styles.textBody}>
              <SimpleBlockContent blocks={text2} noSpace/>
            </div>
          </div>
          <div className={styles.textBody}>
            <SimpleBlockContent blocks={text3} noSpace/>
          </div>
        </div>

      </div>
    </div>
  )
}

export default LiteWheelSpecs
